(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stellarjay-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-media-gallery')) {
    customElements.define('sj-media-gallery', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.();
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const slides = Array.from(this.children);
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let drag;
        const goTo = (index) => {
          const target = slides[Math.max(0, Math.min(slides.length - 1, index))];
          if (target) this.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth' });
        };
        this.toggleAttribute('data-draggable', slides.length > 1);
        this.addEventListener('dragstart', event => event.preventDefault(), options);
        this.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || slides.length < 2 || event.target.closest('button, a, input, video[controls]')) return;
          drag = { id: event.pointerId, x: event.clientX, scroll: this.scrollLeft, moved: false };
        }, options);
        this.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.id) return;
          const delta = event.clientX - drag.x;
          if (!drag.moved && Math.abs(delta) < 5) return;
          drag.moved = true;
          this.setPointerCapture(event.pointerId);
          this.setAttribute('data-dragging', '');
          this.scrollLeft = drag.scroll - delta;
        }, options);
        const finish = event => {
          if (!drag || event.pointerId !== drag.id) return;
          const previous = drag;
          drag = null;
          this.removeAttribute('data-dragging');
          if (this.hasPointerCapture(previous.id)) this.releasePointerCapture(previous.id);
          if (previous.moved) goTo(Math.round(this.scrollLeft / this.clientWidth));
        };
        this.addEventListener('pointerup', finish, options);
        this.addEventListener('pointercancel', finish, options);
        this.addEventListener('lostpointercapture', finish, options);
        this.addEventListener('pointerleave', event => { if (drag && !drag.moved) finish(event); }, options);
        this.addEventListener('keydown', event => {
          if (event.target !== this) return;
          const index = Math.round(this.scrollLeft / this.clientWidth);
          const targets = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: slides.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          goTo(targets[event.key]);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-sj-slide]');
          if (slide) goTo(slides.indexOf(slide));
        }, options);
        // Opt-in navigation: existing Hero/Object behavior and markup stay unchanged.
        if (this.hasAttribute('data-sj-navigation')) {
          const nav = this.parentElement.querySelector('[data-sj-gallery-nav]');
          if (nav && slides.length > 1) {
            nav.hidden = false;
            const previous = nav.querySelector('[data-sj-previous]');
            const next = nav.querySelector('[data-sj-next]');
            const status = nav.querySelector('[data-sj-status]');
            const index = () => Math.round(this.scrollLeft / this.clientWidth);
            const update = () => {
              const current = index();
              previous.disabled = current === 0;
              next.disabled = current === slides.length - 1;
              const label = `${current + 1} / ${slides.length}`;
              if (status.textContent !== label) status.textContent = label;
              slides.forEach((slide, i) => { slide.inert = i !== current; });
            };
            previous.addEventListener('click', () => goTo(index() - 1), options);
            next.addEventListener('click', () => goTo(index() + 1), options);
            this.addEventListener('scroll', update, options);
            update();
          }
        }
        this.cleanup = () => {
          controller.abort();
        };
      }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellarjay-motion-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-motion')) {
    customElements.define('sj-motion', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.();
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        const abort = new AbortController();
        const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: abort.signal });
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const mobile = matchMedia('(max-width: 749px)');
        const autoplay = this.dataset.autoplay === 'true';
        const pauseOffscreen = this.dataset.pauseOffscreen === 'true';
        const mode = this.dataset.controls || 'none';
        let visible = false;
        let manualPause = false;
        let explicitReducedPlay = false;
        let wantsPlay = autoplay && !reduced.matches;
        let blocked = false;
        let failed = false;
        let automaticPauses = 0;
        let activeTemplate;
        let sourcesLoaded = false;
        let generation = 0;
        let disconnected = false;
        const reducedHold = () => reduced.matches && !explicitReducedPlay;
        const hasSource = () => Boolean(activeTemplate?.content.querySelector('source'));
        const update = () => {
          const playing = !video.paused && !video.ended;
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          button.querySelector('[data-motion-label]').textContent = label;
          button.querySelector('[data-motion-icon]').textContent = playing ? 'Ⅱ' : '▷';
          button.setAttribute('aria-label', label);
          button.disabled = failed || !hasSource();
          button.hidden = !hasSource() || !(mode === 'minimal' || reducedHold() || (mode !== 'native' && (!autoplay || blocked)));
          video.controls = mode === 'native' && !reducedHold() && hasSource();
        };
        const pauseAutomatically = () => {
          generation++;
          if (!video.paused) { automaticPauses++; video.pause(); }
        };
        const loadSources = () => {
          if (sourcesLoaded || !hasSource()) return;
          video.append(activeTemplate.content.cloneNode(true));
          sourcesLoaded = true;
          video.load();
        };
        const start = () => {
          if (failed || !hasSource()) return;
          loadSources();
          video.muted = autoplay || this.dataset.muted === 'true';
          const attempt = ++generation;
          video.play().catch(() => {
            if (disconnected || attempt !== generation) return;
            blocked = true;
            wantsPlay = false;
            update();
          });
        };
        const sync = () => {
          if (document.hidden || (pauseOffscreen && !visible) || reducedHold()) pauseAutomatically();
          else if (wantsPlay && !manualPause && !blocked && video.paused) start();
          update();
        };
        const chooseSource = () => {
          const template = this.querySelector(mobile.matches ? '[data-motion-mobile]' : '[data-motion-desktop]');
          if (template === activeTemplate) return;
          const sourceKey = element => Array.from(element.content.querySelectorAll('source'), source => source.getAttribute('src')).join('|');
          if (activeTemplate && sourceKey(template) === sourceKey(activeTemplate)) {
            activeTemplate = template;
            video.poster = template.dataset.poster;
            return;
          }
          pauseAutomatically();
          activeTemplate = template;
          video.querySelectorAll('source').forEach(source => source.remove());
          video.removeAttribute('src');
          sourcesLoaded = false;
          failed = false;
          video.poster = template.dataset.poster;
          video.load();
          if (!reducedHold() && mode === 'native') loadSources();
          sync();
        };
        listen(button, 'click', () => {
          if (!video.paused && !video.ended) {
            manualPause = true;
            wantsPlay = false;
            pauseAutomatically();
          } else {
            explicitReducedPlay = true;
            manualPause = false;
            blocked = false;
            wantsPlay = true;
            start();
          }
          update();
        });
        listen(video, 'play', () => {
          if (video.paused) { update(); return; }
          wantsPlay = true;
          manualPause = false;
          if (document.hidden || (pauseOffscreen && !visible) || reducedHold()) pauseAutomatically();
          update();
        });
        listen(video, 'pause', () => {
          if (automaticPauses > 0) automaticPauses--;
          else if (video.paused && !video.ended) { manualPause = true; wantsPlay = false; }
          update();
        });
        listen(video, 'ended', () => {
          wantsPlay = false;
          if (mode === 'none') blocked = true;
          update();
        });
        listen(video, 'error', () => { failed = true; wantsPlay = false; update(); });
        listen(reduced, 'change', () => {
          explicitReducedPlay = false;
          wantsPlay = autoplay && !reduced.matches && !manualPause;
          if (reduced.matches) {
            pauseAutomatically();
            video.querySelectorAll('source').forEach(source => source.remove());
            sourcesLoaded = false;
            video.load();
          } else if (mode === 'native') loadSources();
          sync();
        });
        listen(mobile, 'change', chooseSource);
        listen(document, 'visibilitychange', sync);
        const observer = new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          sync();
        }, { threshold: 0 });
        observer.observe(this);
        chooseSource();
        this.cleanup = () => {
          disconnected = true;
          generation++;
          abort.abort();
          observer.disconnect();
          video.pause();
          video.querySelectorAll('source').forEach(source => source.remove());
          video.removeAttribute('src');
          video.load();
        };
      }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellarjay-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sj-video-media')) {
    customElements.define('sj-video-media', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.();
        const video = this.querySelector('video');
        if (!video) return;
        const button = this.querySelector('button');
        const abort = new AbortController();
        const listen = (target, type, handler) => target.addEventListener(type, handler, { signal: abort.signal });
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let visible = false;
        let explicitPlay = false;
        let wantsPlay = this.dataset.autoplay === 'true';
        let blocked = false;
        let failed = false;
        let pending = false;
        let disposed = false;
        let automaticPauses = 0;
        let generation = 0;
        // No HTML autoplay attribute: visibility and motion preferences gate every automatic start.
        video.muted = video.hasAttribute('muted');
        const eligible = () => visible && !document.hidden && (!reduced.matches || explicitPlay);
        const update = () => {
          if (!button) return;
          button.hidden = false;
          button.disabled = failed;
          button.textContent = !video.paused && !video.ended ? button.dataset.pauseLabel : button.dataset.playLabel;
        };
        const pause = () => {
          generation++;
          pending = false;
          if (!video.paused) {
            automaticPauses++;
            video.pause();
          }
          update();
        };
        const start = () => {
          if (pending || failed || !eligible()) return;
          const attempt = ++generation;
          pending = true;
          video.play().then(() => {
            if (disposed || attempt !== generation) return;
            pending = false;
            if (!eligible()) pause();
            update();
          }).catch(() => {
            if (disposed || attempt !== generation) return;
            pending = false;
            blocked = true;
            // Keep the configured mute state and controls; do not retry rejected autoplay in a loop.
            this.setAttribute('data-playback-blocked', '');
            update();
          });
        };
        const sync = () => {
          if (!eligible()) pause();
          else if (wantsPlay && !blocked && video.paused) start();
        };
        if (button) listen(button, 'click', () => {
          if (!video.paused && !video.ended) {
            wantsPlay = false;
            pause();
          } else {
            explicitPlay = true;
            wantsPlay = true;
            blocked = false;
            this.removeAttribute('data-playback-blocked');
            start();
          }
        });
        listen(video, 'play', () => {
          if (video.paused) return;
          // Native controls can explicitly start playback even with reduced motion enabled.
          if (!pending) explicitPlay = true;
          wantsPlay = true;
          blocked = false;
          this.removeAttribute('data-playback-blocked');
          if (!eligible()) pause();
          update();
        });
        listen(video, 'pause', () => {
          if (automaticPauses) automaticPauses--;
          else if (!video.ended) wantsPlay = false;
          update();
        });
        listen(video, 'ended', () => { wantsPlay = false; update(); });
        listen(video, 'error', () => { failed = true; wantsPlay = false; update(); });
        listen(reduced, 'change', () => { explicitPlay = false; sync(); });
        listen(document, 'visibilitychange', sync);
        const observer = new IntersectionObserver(([entry]) => {
          // The browser also clips this intersection against a containing gallery's scroll frame.
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          sync();
        }, { threshold: [0, 0.5] });
        observer.observe(this);
        update();
        this.cleanup = () => {
          disposed = true;
          generation++;
          abort.abort();
          observer.disconnect();
          video.pause();
        };
      }
      disconnectedCallback() { this.cleanup?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
